export default function EmptyResult({ message }) {
	return (
		<div className="flex items-center justify-center empty-container max-w-5xl">
            <div>
				{message === undefined ? "No data found" : message}
            </div>
        </div>
	);
}
